import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';

export const BannerRoot = styled(Stack)<{ ownerState: { bottom?: string; top?: string } }>(
  ({ ownerState }) => ({
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    ...(ownerState.bottom ? { bottom: ownerState.bottom } : {}),
    ...(ownerState.top ? { top: ownerState.top } : {}),
    zIndex: 1300,
    display: 'inline-flex',
    width: 'max-content',
    maxWidth: '90vw',
    backgroundColor: '#ffffff',
    borderRadius: '1rem',
    boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.16)',
    padding: '1rem 1.6rem',
    gap: '1.2rem',
    fontSize: '1.3rem',
    lineHeight: '2rem',
    color: '#0d1824',
    fontWeight: 400,
    alignItems: 'center',
    flexDirection: 'row',
    '& strong, & b': { fontWeight: 600 },
    '& .MuiSvgIcon-root': { fontSize: '2rem', flexShrink: 0 },
    '& svg': { width: '2rem', height: '2rem', flexShrink: 0 },
  })
);

export const BannerIconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});
